import React, { Fragment } from "react";
import { Divider } from "@material-ui/core";
import { CONSULTATION_TYPE, CONSULTATION_TYPE_VALUE } from "../constant";
import moment from "moment";

const PopoverContent = (props) => {
  const { doctorData } = props;

  const teleConsultFee = (data, indx) => {
    let display = null;
    if (
      data?.consultation_type.toString() ===
      CONSULTATION_TYPE.TELE_CONSULT_REGULAR
    ) {
      display = (
        <p className="d-flex poper-content justify-view mb-1" key={indx}>
          <span className="dashboard-accounts-default-procedure-view">
            {CONSULTATION_TYPE_VALUE.TELE_CONSULT_REGULAR}
          </span>{" "}
          : &nbsp;₹{data?.fees}
        </p>
      );
    } else if (
      data.consultation_type.toString() ===
      CONSULTATION_TYPE.TELE_CONSULT_FOLLOW_UP
    ) {
      display = (
        <p className="d-flex poper-content justify-view mb-1" key={indx}>
          <span className="dashboard-accounts-default-procedure-view">
            {CONSULTATION_TYPE_VALUE.TELE_CONSULT_FOLLOW_UP}
          </span>
          : &nbsp;₹{data?.fees}
        </p>
      );
    }
    return display;
  };

  const inclinicConsultFee = (data, indx) => {
    let display = null;
    if (
      data.consultation_type.toString() === CONSULTATION_TYPE.IN_CLINIC_REGULAR
    ) {
      display = (
        <p className="d-flex poper-content justify-view mb-1" key={indx}>
          <span className="dashboard-accounts-inclinic-procedure-view">
            {CONSULTATION_TYPE_VALUE.IN_CLINIC_REGULAR}
          </span>{" "}
          : &nbsp;₹{data?.fees}
        </p>
      );
    } else if (
      data.consultation_type.toString() ===
      CONSULTATION_TYPE.IN_CLINIC_FOLLOW_UP
    ) {
      display = (
        <p className="d-flex poper-content justify-view mb-1" key={indx}>
          <span className="dashboard-accounts-inclinic-procedure-view">
            {CONSULTATION_TYPE_VALUE.IN_CLINIC_FOLLOW_UP}
          </span>{" "}
          : &nbsp;₹{data?.fees}
        </p>
      );
    }
    return display;
  };

  const slotAvailability = (
    start_date,
    end_date,
    start_time,
    end_time,
    days,
    dayClass
  ) => {
    const startDateFormatted = moment(start_date).format("MMM D, YYYY");
    const endDateFormatted = moment(end_date).format("MMM D, YYYY");
    const startTimeFormatted = moment(start_time, "hh:mm A").format("hh:mm A");
    const endTimeFormatted = moment(end_time, "hh:mm A").format("hh:mm A");

    let daysFormatted = "";
    if (Array.isArray(days)) {
      if (days.length === 7) {
        daysFormatted = "All Days";
      } else {
        daysFormatted = days
          .map((day) => moment().day(day).format("ddd"))
          .join(", ");
      }
    } else {
      daysFormatted = days;
    }
    const availabilityText = `${startDateFormatted} - ${endDateFormatted} : ${startTimeFormatted} - ${endTimeFormatted} (${daysFormatted})`;
    return (
      <p
        className="poper-content m-0 mb-2"
        style={{
          color: start_time && end_time ? "" : "#17bae0",
        }}
      >
        <span className={dayClass}>{availabilityText}</span>
      </p>
    );
  };

  const vacationDetails = () => {
    return (
      <Fragment>
        <Divider />
        <p
          className="d-flex poper-content m-0 mb-2 mt-2 justify-view"
          style={{ color: "red" }}
        >
          <span className="vacations-view">On Vacation</span> : &nbsp;
          {doctorData?.upcoming_vacation_start_date &&
          doctorData?.upcoming_vacation_end_date
            ? viewVacationDate()
            : null}
        </p>
      </Fragment>
    );
  };

  const viewVacationDate = () => {
    return doctorData?.upcoming_vacation_start_date ===
      doctorData?.upcoming_vacation_end_date ? (
      <span className="slot-avail">
        {moment(doctorData?.upcoming_vacation_start_date).format(
          "DD MMM yyyy(dddd)"
        )}
      </span>
    ) : (
      <span className="slot-avail">
        {moment(doctorData?.upcoming_vacation_start_date).format(
          "DD MMM yyyy(dddd)"
        )}{" "}
        -{" "}
        {moment(doctorData?.upcoming_vacation_end_date).format(
          "DD MMM yyyy(dddd)"
        )}
      </span>
    );
  };

  const displayDoctorAvailability = () => {
    const scheduleArray = doctorData?.date_wise_schedule;
    if (!scheduleArray || scheduleArray.length === 0) {
      return (
        <div>
          <p className="poper-heading">Doctor Availability :</p>
          <p
            className="d-flex poper-content m-0 justify-view"
            style={{ color: "#17bae0" }}
          >
            No slots available
          </p>
        </div>
      );
    }
    return (
      <div>
        <p className="poper-heading">Doctor Availability</p>
        <div className="poper-content m-0 mb-1 justify-view">
          {scheduleArray?.map((schedule, index) => {
            const daysArray = schedule?.days ? schedule?.days : [];
            return (
              <div key={index}>
                {slotAvailability(
                  schedule.start_date,
                  schedule.end_date,
                  schedule.start_time,
                  schedule.end_time,
                  daysArray,
                  "days-view days2-view"
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const popoverBody = () => {
    return (
      <div
        className={"popover-content__description"}
        style={{ padding: "20px 20px 0px" }}
      >
        <div className="mb-3">
          <p className="poper-heading">Contact No.</p>
          <p className="d-flex poper-content m-0 mb-1 justify-view">
            <span className="dashboard-accounts-contact-no-view">
              For Consultations
            </span>{" "}
            : &nbsp;
            {doctorData?.doctor_phone_no}
          </p>
          {doctorData?.doctor_alternate_no && (
            <p className="d-flex poper-content m-0 justify-view">
              <span className="dashboard-accounts-contact-no-view">
                Alternate No
              </span>{" "}
              : &nbsp;
              {doctorData?.doctor_alternate_no}
            </p>
          )}
        </div>
        {doctorData?.settings &&
          Array.isArray(doctorData?.settings) &&
          doctorData?.settings?.length > 0 &&
          doctorData?.settings[0]?.fees !== "" && (
            <div className="mb-3">
              <p className="poper-heading">Fee</p>
              <div
                className="d-flex flex-lg-row flex-column"
                style={{ width: "100%" }}
              >
                <div className="dashboard-accounts-fee-view">
                  {doctorData?.settings?.map((data, indx) =>
                    teleConsultFee(data, indx)
                  )}
                </div>
                <div className="dashboard-accounts-fee1-view">
                  {doctorData?.settings?.map((data, indx) =>
                    inclinicConsultFee(data, indx)
                  )}
                </div>
              </div>
            </div>
          )}
        {displayDoctorAvailability()}
        {doctorData?.upcoming_vacation_start_date &&
        doctorData?.upcoming_vacation_end_date ? (
          vacationDetails()
        ) : (
          <div style={{ marginBottom: "15px" }}></div>
        )}
      </div>
    );
  };

  return <div className={"popover-content"}>{popoverBody()}</div>;
};
export default PopoverContent;
